type AnalyticsPayload = Record<string, string | number | boolean | null>;

const forbiddenKeys = ["name", "email", "phone", "message", "filename", "organization"];

export function track(event: string, payload: AnalyticsPayload = {}) {
  const provider = import.meta.env.VITE_ANALYTICS_PROVIDER;
  const safePayload = Object.fromEntries(
    Object.entries(payload).filter(([key]) => !forbiddenKeys.some((blocked) => key.toLowerCase().includes(blocked)))
  );

  window.dispatchEvent(new CustomEvent("ptd:analytics", { detail: { event, payload: safePayload } }));

  if (provider === "debug") {
    console.info("[analytics]", event, safePayload);
  }
}
